<!-- src/comonets/quote.html -->
<div class='container-float'>

  <b-row class="mb-3">
    <b-col cols="12">&nbsp;</b-col>
  </b-row>

  <b-alert v-model="showAlertMandatoryQty" variant="warning" dismissible>La quantità è un parametro obbligatorio</b-alert>
  <b-alert v-model="showAlertMandatoryLocations" variant="warning" dismissible>Le locazioni sono obbligatorie</b-alert>
  <b-alert v-model="showAlertMandatoryNotFound" variant="info" dismissible>Nessun dato trovato con i parametri impostati</b-alert>
  <b-alert v-model="showAlertPesoIncoerente" variant="warning" dismissible> I campi max_peso_ingombro, weight e volume devono essere compilati tutti o lasciati vuoti!</b-alert>

  <b-row class="mb-3">
    <b-col cols="12">
      <b-card title="Richiesta Preventivo">
        <b-card-body style="text-align: left;">

          <b-row>
            <b-col cols='6'><div class='label'>Cliente</div></b-col>
            <b-col cols='6'><div class='label'>Listino</div></b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols='6'>
              <select class="custom-select" v-model="selectedCustomer" @change="updatePriceList">
                <option :value="null"></option>
                <option v-for="c in customers" :key="c.id" :value="c.id">{{ c.company }}</option>
              </select>
            </b-col>
            <b-col cols='6'>
              <select class="custom-select" v-model="selectedPriceListName">
                <option value=""></option>
                <option v-for="p in price_list_names" :key="p.id" :value="p.price_list_name">{{ p.price_list_name }}</option>
              </select>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='6'><div class='label'>Unità di misura</div></b-col>
            <b-col cols='3'><div class='label'>Quantità</div></b-col>
            <b-col cols='3'><div class='label'>Valuta</div></b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols='6'>
              <select class="custom-select" v-model="selectedUM">
                <option :value="null"></option>
                <option v-for="u in measure_units" :key="u.id" :value="u.id">{{ u.measure_unit }}</option>
              </select>
            </b-col>
            <b-col cols='3'><b-form-input v-model="quantity" type="number" class="custom-input"></b-form-input></b-col>
            <b-col cols='3'>
              <select class="custom-select" v-model="selectedCurrency">
                <option :value="null"></option>
                <option v-for="curr in currencies" :key="curr.id" :value="curr.id">{{ curr.currency }}</option>
              </select>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='6'><div class='label'>Locazione 1</div></b-col>
            <b-col cols='6'><div class='label'>Locazione 2</div></b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols='6'>
              <select class="custom-select" v-model="selectedLocationId1">
                <option :value="null"></option>
                <option v-for="l in locations" :key="l.value" :value="l.value">{{ l.text }}</option>
              </select>
            </b-col>
            <b-col cols='6'>
              <select class="custom-select" v-model="selectedLocationId2">
                <option :value="null"></option>
                <option v-for="l in locations" :key="l.value" :value="l.value">{{ l.text }}</option>
              </select>
            </b-col>
          </b-row>

          <b-row><b-col cols="12"><div class='label'>Base</div></b-col></b-row>
          <b-row class="mb-3">
            <b-col cols="12">
              <select class="custom-select" v-model="selectedBase">
                <option :value="null"></option>
                <option v-for="b in bases" :key="b.id" :value="b.id">{{ b.base_code }}</option>
              </select>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='5'><div class='label'>Scaglione minimo</div></b-col>
            <b-col cols='5'><div class='label'>Scaglione massimo</div></b-col>
            <b-col cols='2'><div class='label'>UM Scaglione</div></b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols='5'><b-form-input v-model="lower_end_bracket" class="custom-input"></b-form-input></b-col>
            <b-col cols='5'><b-form-input v-model="upper_end_bracket" class="custom-input"></b-form-input></b-col>
            <b-col cols='2'>
              <select class="custom-select" v-model="selectedBracketMeasureUnit">
                <option :value="null"></option>
                <option v-for="bu in bracket_measure_units" :key="bu.id" :value="bu.id">{{ bu.measure_unit }}</option>
              </select>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='4'><div class='label'>Formula</div></b-col>
            <b-col cols='4'><div class='label'>Voce attiva</div></b-col>
            <b-col cols='4'><div class='label'>Voce passiva</div></b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols='4'>
              <select class="custom-select" v-model="selectedCalculationFormula">
                <option :value="null"></option>
                <option v-for="f in calculation_formulas" :key="f.id" :value="f.id">{{ f.formula }}</option>
              </select>
            </b-col>
            <b-col cols='4'><b-form-input v-model="active_voice" class="custom-input"></b-form-input></b-col>
            <b-col cols='4'><b-form-input v-model="passive_voice" class="custom-input"></b-form-input></b-col>
          </b-row>

          <b-row>
            <b-col cols='4'><div class='label'>Tipologia merce</div></b-col>
            <b-col cols='4'><div class='label'>Tipologia imballaggio</div></b-col>
            <b-col cols='4'><div class='label'>Dimensioni equipaggiamento</div></b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols='4'>
              <select class="custom-select" v-model="selectedGoodsKind">
                <option :value="null"></option>
                <option v-for="gk in goods_kinds" :key="gk.id" :value="gk.id">{{ gk.kind }}</option>
              </select>
            </b-col>
            <b-col cols='4'>
              <select class="custom-select" v-model="selectedPackagingKind">
                <option :value="null"></option>
                <option v-for="pk in packaging_kinds" :key="pk.id" :value="pk.id">{{ pk.description }}</option>
              </select>
            </b-col>
            <b-col cols='4'>
              <select class="custom-select" v-model="selectedEquipmentSize">
                <option :value="null"></option>
                <option v-for="es in equipment_sizes" :key="es.id" :value="es.id">{{ es.size }}</option>
              </select>
            </b-col>
          </b-row>

          <b-row class="mt-4 p-2" style="background-color: #f8f9fa; border-radius: 5px;">
            <b-col cols='4'>
              <div class='label'><strong>Free Time (GG)</strong></div> 
              <b-form-input v-model="free_time" type="number" class="custom-input"></b-form-input>
            </b-col>
            <b-col cols='4'>
              <div class='label'><strong>Coef. Peso (Ingombro)</strong></div> 
              <b-form-input v-model="max_peso_ingombro" type="number" class="custom-input" placeholder="es. 300"></b-form-input>
            </b-col>
            <b-col cols='4'>
              <div class='label'><strong>Peso Reale (Kg)</strong></div> 
              <b-form-input v-model="weight" type="number" class="custom-input"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-4 p-2" style="background-color: #f8f9fa; border-radius: 5px;">
            <b-col cols='3'>
              <div class='label'><strong>Lunghezza (cm)</strong></div> 
              <b-form-input v-model="lenght_obj" type="number" class="custom-input" @blur="calculateVolumeFromDimensions"></b-form-input>
            </b-col>
            <b-col cols='3'>
              <div class='label'><strong>Larghezza (cm)</strong></div> 
              <b-form-input v-model="width_obj" type="number" class="custom-input" @blur="calculateVolumeFromDimensions"></b-form-input>
            </b-col>
            <b-col cols='3'>
              <div class='label'><strong>Profondità (cm)</strong></div> 
              <b-form-input v-model="depth_obj" type="number" class="custom-input" @blur="calculateVolumeFromDimensions"></b-form-input>
            </b-col>
            <b-col cols='3'>
              <div class='label'><strong>Volume (m³)</strong></div> 
              <b-form-input v-model="volume" type="number" class="custom-input" @input="clearParams"></b-form-input>
            </b-col>
          </b-row>


          <b-row class="mt-4">
            <b-col cols="3"><b-button variant="outline-warning" block @click="clearQuote">Azzera preventivi</b-button></b-col>
            <b-col cols="3"><b-button variant="outline-danger" block @click="clearFilter">Pulisci dati</b-button></b-col>
            <b-col cols="3"><b-button variant="outline-info" block @click="exportToExcel">Esporta Excel</b-button></b-col>
            <b-col cols="3"><b-button variant="primary" block @click="calculateQuote">Calcola preventivo</b-button></b-col>
          </b-row>

        </b-card-body>
      </b-card>
    </b-col>
  </b-row>

  <b-row>
    <b-col cols="12">
      <b-table striped hover :items="prices_list_rows" :fields="prices_list_columns" show-empty empty-text="Nessuna riga nel preventivo"></b-table>
    </b-col>
  </b-row>

</div>